module.exports = __webpack_public_path__ + "static/media/x.4b726d20.svg";